import React from 'react';
import { Button, Grid } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import { Link } from 'react-router-dom';
import ActivityCardForCompare from './ActivityCardForCompare';

function CompareActivities({ compareActivities, clearCompareList, removeActivityFromCompareList }) {
    if (compareActivities.length === 0) {
        return null;
    }
    return (
        <Grid
            item
            container
            spacing={2}
            xs={12}
            style={{
                backgroundColor: '#f6f6f6',
                position: 'sticky',
                bottom: '0px',
                zIndex: '10',
                height: 150
            }}
        >
            {compareActivities.map((a, key) => (
                <ActivityCardForCompare
                    key={a?.id || key}
                    activity={a}
                    minRetailPrice={a?.minTicketRetailPrice}
                    onRemove={() => removeActivityFromCompareList(a?.id)}
                />
            ))}
            {Array(3 - compareActivities.length)
                .fill(undefined)
                .map((v, index) => (
                    <Grid item xs={3} key={index}>
                        <div
                            style={{
                                border: '1px dotted',
                                height: '128px'
                            }}
                        ></div>
                    </Grid>
                ))}
            <Grid item container xs={3}>
                <Grid item xs={12}>
                    <Grid item>
                        <p style={{ textAlign: 'center' }}>Select up to 3 activities to compare</p>
                    </Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        style={{ color: 'default' }}
                        component={Link}
                        to={
                            compareActivities.length > 2
                                ? `/compare/${compareActivities[0]?.id}/${compareActivities[1]?.id}/${compareActivities[2]?.id}?`
                                : `/compare/${compareActivities[0]?.id}/${compareActivities[1]?.id}`
                        }
                        disabled={compareActivities.length < 2}
                    >
                        Compare
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <h5
                        onClick={clearCompareList}
                        style={{ textAlign: 'center', cursor: 'pointer' }}
                    >
                        Clear all
                    </h5>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default withTheme(CompareActivities);
